<template>
    <transition name="ui-overlay-fade">
    	<div class="ui-overlay" v-if="show" @click="handleClick" @touchmove="prevent" :style="overlayStyle" ></div>
    </transition>
</template>

<script>
	export default {
		name: 'ui-overlay',
		props: {
			show: {
	      		type: Boolean,
	      		default: false
	    	},
	   		fixed: {
	      		type: Boolean,
	      		default: false
	    	},
	    	onClick: {
	      		type: Function
	    	},
	    	opacity: {
	      		type: Number,
	      		default: 0.4
	    	},
	    	color: {
	      		type: String,
	      		default: '#000'
	    	},
	    	zIndex: {
	      		type: Number
	   		}
		},
		computed: {
	    	overlayStyle () {
	      		return {
	        		'opacity': this.opacity,
	        		'background-color': this.color,
	        		'position': this.fixed ? 'fixed' : '',
	        		'z-index': this.zIndex
	      		}
	    	}
  		},
  		methods: {
	    	prevent (event) {
	      		event.preventDefault()
	      		event.stopPropagation()
	    	},
	    	handleClick () {
	      		if (this.onClick) {
	        		this.onClick()
	      		}
	    	}
  		}
	}
</script>

<style lang="css">
.ui-overlay {
  	position: absolute;
  	left: 0;
  	right: 0;
  	top: 0;
  	bottom: 0;
  	background-color: #000;
  	opacity: .4;
  	z-index: 1000;
}

.ui-overlay-fade-enter-active, .ui-overlay-fade-leave-active {
  	transition: opacity .45s cubic-bezier(0.23, 1, 0.32, 1);
}

.ui-overlay-fade-enter,
.ui-overlay-fade-leave-active {
  	opacity: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/modal/overlay.vue